import { Link } from "react-router-dom";
import { useIntl } from "react-intl";
import { UserIcon, BadgeCheckIcon } from "@heroicons/react/outline";

const Tabs = () => {
  const { formatMessage: f } = useIntl();

  return (
    <div>
      <div className="sm:hidden">
        <select className="form-select block w-full" defaultValue="Kompetenzen">
          <option>{f({ id: "employees.name" })}</option>
          <option>{f({ id: "reviews.name" })}</option>
        </select>
      </div>
      <div className="hidden sm:block">
        <div className="border-b border-gray-200">
          <nav className="flex -mb-px">
            <Link
              to="/employees"
              className="group inline-flex items-center py-4 px-1 border-b-2 border-transparent font-medium text-sm leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300"
            >
              <UserIcon className="mr-1 h-6 w-6 text-gray-400 group-hover:text-gray-500" />
              <span>{f({ id: "employees.name" })}</span>
            </Link>
            <Link
              to="/reviews"
              className="ml-8 group inline-flex items-center py-4 px-1 border-b-2 border-transparent font-medium text-sm leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300"
            >
              <BadgeCheckIcon className="mr-1 h-5 w-5 text-gray-400 group-hover:text-gray-500" />
              <span>{f({ id: "reviews.name" })}</span>
            </Link>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Tabs;
